import { callAPI } from "../../config/AxiosTemplate";
import { API } from "../../constants/APIConstants";

export const getLoanProcessTableData = (loanProcessId, callBack) => {
  let requestString = API.getLoanProcessTable + loanProcessId;

  callAPI(
    "getLoanProcessTableData",
    requestString,
    "GET",
    {},
    (apiResponse) => {
      callBack(apiResponse)
    }
  )
}

export const getLoanApplicationDataTable = (loanProcessId, callBack) => {
  let requestString = API.getLoanApplicationTable + loanProcessId;

  callAPI(
    "getLoanApplicationTableData",
    requestString,
    "GET",
    {},
    (apiResponse) => {
      callBack(apiResponse)
    }
  )
}

export const getDailyOperationsV2DataAction = (loanProcessId, callBack) => {
  let requestString = API.getDailyOperationsV2 + loanProcessId;

  callAPI(
    "getDailyOperationsV2Data",
    requestString,
    "GET",
    {},
    (apiResponse) => {
      callBack(apiResponse)
    }
  )
}

export const getAmortizationV2TableDataAction = (loanProcessId, callBack) => {
  let requestString = API.getAmortizationV2Table + loanProcessId;
  callAPI(
    "getAmortizationV2TableData",
    requestString,
    "GET",
    {},
    (apiResponse) => {
      callBack(apiResponse)
    }
  )
}

export const getEmiRecieptsTableDataAction = (loanProcessId, callBack) => {
  let requestString = API.getEmiRecieptsTable + loanProcessId;
  callAPI(
    "getEmiRecieptsTableData",
    requestString,
    "GET",
    {},
    (apiResponse) => {
      callBack(apiResponse)
    }
  )
}

export const getReceiptTableDataAction = (loanProcessId, callBack) => {

  let requestString = API.getRecieptTable + loanProcessId;
  callAPI(
    "getReceiptTableData",
    requestString,
    "GET",
    {},
    (apiResponse) => {
      callBack(apiResponse)
    }
  )
}

// ── Duplicate entry management ───────────────────────────────────────────────

export const getApprovalAssignmentsAction = (applicationId, callBack) => {
  callAPI(
    "getApprovalAssignments",
    `${API.duplicateApprovalAssignment}?applicationId=${applicationId}`,
    "GET", {}, (apiResponse) => callBack(apiResponse)
  );
};

export const deleteApprovalAssignmentAction = (id, callBack) => {
  callAPI(
    "deleteApprovalAssignment",
    `${API.duplicateApprovalAssignment}/${id}`,
    "DELETE", {}, (apiResponse) => callBack(apiResponse)
  );
};

export const getRemittanceDeliveriesAction = (applicationId, callBack) => {
  callAPI(
    "getRemittanceDeliveries",
    `${API.duplicateRemittanceDelivery}?applicationId=${applicationId}`,
    "GET", {}, (apiResponse) => callBack(apiResponse)
  );
};

export const deleteRemittanceDeliveryAction = (id, callBack) => {
  callAPI(
    "deleteRemittanceDelivery",
    `${API.duplicateRemittanceDelivery}/${id}`,
    "DELETE", {}, (apiResponse) => callBack(apiResponse)
  );
};

export const getLoanApplicationAction = (applicationId, callBack) => {
  callAPI(
    "getLoanApplication",
    `${API.loanApplication}?applicationId=${applicationId}`,
    "GET", {}, (apiResponse) => callBack(apiResponse)
  );
};

export const fixLoanFormFilledAction = (applicationId, callBack) => {
  callAPI(
    "fixLoanFormFilled",
    `${API.loanApplication}/${applicationId}/form-filled`,
    "PATCH", {}, (apiResponse) => callBack(apiResponse)
  );
};

export const updateLoanApplicationAction = (applicationId, body, callBack) => {
  callAPI(
    "updateLoanApplication",
    `${API.loanApplication}/${applicationId}`,
    "PATCH", body, (apiResponse) => callBack(apiResponse)
  );
};

export const getNotesAction = (applicationId, callBack) => {
  callAPI(
    "getNotes",
    `${API.duplicateNotes}?applicationId=${applicationId}`,
    "GET", {}, (apiResponse) => callBack(apiResponse)
  );
};

export const deleteNoteAction = (id, callBack) => {
  callAPI(
    "deleteNote",
    `${API.duplicateNotes}/${id}`,
    "DELETE", {}, (apiResponse) => callBack(apiResponse)
  );
};


export const getLoanProcessAction = (applicationId, callBack) => {
  callAPI(
    "getLoanProcess",
    `${API.duplicateLoanProcess}?applicationId=${applicationId}`,
    "GET", {}, (apiResponse) => callBack(apiResponse)
  );
};

export const deleteLoanProcessAction = (id, callBack) => {
  callAPI(
    "deleteLoanProcess",
    `${API.duplicateLoanProcess}/${id}`,
    "DELETE", {}, (apiResponse) => callBack(apiResponse)
  );
};

// ── Payment reversal ─────────────────────────────────────────────────────────

// Group A views (by loanProcessId)
export const getReversalLoanProcessAction = (loanProcessId, callBack) => {
  callAPI("getReversalLoanProcess", `${API.reversalLoanProcess}/${loanProcessId}`,
    "GET", {}, (apiResponse) => callBack(apiResponse));
};

export const getReversalAmortizationV2Action = (loanProcessId, callBack) => {
  callAPI("getReversalAmortizationV2", `${API.reversalAmortizationV2}/${loanProcessId}`,
    "GET", {}, (apiResponse) => callBack(apiResponse));
};

export const getReversalDailyOperationV2Action = (loanProcessId, callBack) => {
  callAPI("getReversalDailyOperationV2", `${API.reversalDailyOperationV2}/${loanProcessId}`,
    "GET", {}, (apiResponse) => callBack(apiResponse));
};

export const getReversalReceiptAction = (loanProcessId, callBack) => {
  callAPI("getReversalReceipt", `${API.reversalReceipt}/${loanProcessId}`,
    "GET", {}, (apiResponse) => callBack(apiResponse));
};

export const getReversalEmiReceiptAction = (loanProcessId, callBack) => {
  callAPI("getReversalEmiReceipt", `${API.reversalEmiReceipt}/${loanProcessId}`,
    "GET", {}, (apiResponse) => callBack(apiResponse));
};

export const getReversalDailyProcessAction = (loanProcessId, callBack) => {
  callAPI("getReversalDailyProcess", `${API.reversalDailyProcess}/${loanProcessId}`,
    "GET", {}, (apiResponse) => callBack(apiResponse));
};

export const getReversalLoanAuditAction = (loanProcessId, callBack) => {
  callAPI("getReversalLoanAudit", `${API.reversalLoanAudit}/${loanProcessId}`,
    "GET", {}, (apiResponse) => callBack(apiResponse));
};

export const getReversalLoanWorkflowAction = (loanProcessId, callBack) => {
  callAPI("getReversalLoanWorkflow", `${API.reversalLoanWorkflow}/${loanProcessId}`,
    "GET", {}, (apiResponse) => callBack(apiResponse));
};

// Group A mutations
export const deleteReversalReceiptAction = (id, callBack) => {
  callAPI("deleteReversalReceipt", `${API.reversalReceipt}/${id}`,
    "DELETE", {}, (apiResponse) => callBack(apiResponse));
};

export const deleteReversalEmiReceiptAction = (id, callBack) => {
  callAPI("deleteReversalEmiReceipt", `${API.reversalEmiReceipt}/${id}`,
    "DELETE", {}, (apiResponse) => callBack(apiResponse));
};

export const deleteReversalDailyOperationV2Action = (id, callBack) => {
  callAPI("deleteReversalDailyOperationV2", `${API.reversalDailyOperationV2}/${id}`,
    "DELETE", {}, (apiResponse) => callBack(apiResponse));
};

export const deleteReversalDailyProcessAction = (id, callBack) => {
  callAPI("deleteReversalDailyProcess", `${API.reversalDailyProcess}/${id}`,
    "DELETE", {}, (apiResponse) => callBack(apiResponse));
};

export const deleteReversalLoanWorkflowAction = (id, callBack) => {
  callAPI("deleteReversalLoanWorkflow", `${API.reversalLoanWorkflow}/${id}`,
    "DELETE", {}, (apiResponse) => callBack(apiResponse));
};

export const updateReversalLoanProcessAction = (id, body, callBack) => {
  callAPI("updateReversalLoanProcess", `${API.reversalLoanProcess}/${id}`,
    "PATCH", body, (apiResponse) => callBack(apiResponse));
};

export const updateReversalAmortizationV2Action = (id, body, callBack) => {
  callAPI("updateReversalAmortizationV2", `${API.reversalAmortizationV2}/${id}`,
    "PATCH", body, (apiResponse) => callBack(apiResponse));
};

export const insertReversalLoanAuditAction = (body, callBack) => {
  callAPI("insertReversalLoanAudit", `${API.reversalLoanAudit}`,
    "POST", body, (apiResponse) => callBack(apiResponse));
};

// Group B views (by manual secondary key)
export const getReversalDailyStatusMessengerAction = (dailyStatusMessengerId, callBack) => {
  callAPI("getReversalDailyStatusMessenger",
    `${API.reversalDailyStatusMessenger}?dailyStatusMessengerId=${dailyStatusMessengerId}`,
    "GET", {}, (apiResponse) => callBack(apiResponse));
};

export const getReversalLoanPaymentAuditAction = (branchId, month, callBack) => {
  callAPI("getReversalLoanPaymentAudit",
    `${API.reversalLoanPaymentAudit}?branchId=${branchId}&month=${month}`,
    "GET", {}, (apiResponse) => callBack(apiResponse));
};

export const getReversalMessengerDepositAction = (messengerDepositId, callBack) => {
  callAPI("getReversalMessengerDeposit",
    `${API.reversalMessengerDeposit}?messengerDepositId=${messengerDepositId}`,
    "GET", {}, (apiResponse) => callBack(apiResponse));
};

export const getReversalMessengerCashLimitLogAction = (messengerDepositId, callBack) => {
  callAPI("getReversalMessengerCashLimitLog",
    `${API.reversalMessengerCashLimitLog}?messengerDepositId=${messengerDepositId}`,
    "GET", {}, (apiResponse) => callBack(apiResponse));
};

// Group B mutations
export const updateReversalDailyStatusMessengerAction = (id, body, callBack) => {
  callAPI("updateReversalDailyStatusMessenger", `${API.reversalDailyStatusMessenger}/${id}`,
    "PATCH", body, (apiResponse) => callBack(apiResponse));
};

export const updateReversalLoanPaymentAuditAction = (id, body, callBack) => {
  callAPI("updateReversalLoanPaymentAudit", `${API.reversalLoanPaymentAudit}/${id}`,
    "PATCH", body, (apiResponse) => callBack(apiResponse));
};

export const deleteReversalMessengerDepositAction = (id, callBack) => {
  callAPI("deleteReversalMessengerDeposit", `${API.reversalMessengerDeposit}/${id}`,
    "DELETE", {}, (apiResponse) => callBack(apiResponse));
};

export const updateReversalMessengerDepositAction = (id, body, callBack) => {
  callAPI("updateReversalMessengerDeposit", `${API.reversalMessengerDeposit}/${id}`,
    "PATCH", body, (apiResponse) => callBack(apiResponse));
};

export const deleteReversalMessengerCashLimitLogAction = (id, callBack) => {
  callAPI("deleteReversalMessengerCashLimitLog", `${API.reversalMessengerCashLimitLog}/${id}`,
    "DELETE", {}, (apiResponse) => callBack(apiResponse));
};

export const updateReversalMessengerCashLimitLogAction = (id, body, callBack) => {
  callAPI("updateReversalMessengerCashLimitLog", `${API.reversalMessengerCashLimitLog}/${id}`,
    "PATCH", body, (apiResponse) => callBack(apiResponse));
};

export const getReversalMinimartAction = (minimartId, callBack) => {
  callAPI("getReversalMinimart", `${API.reversalMinimart}?minimartId=${minimartId}`,
    "GET", {}, (apiResponse) => callBack(apiResponse));
};

export const updateReversalMinimartAction = (id, body, callBack) => {
  callAPI("updateReversalMinimart", `${API.reversalMinimart}/${id}`,
    "PATCH", body, (apiResponse) => callBack(apiResponse));
};

export const getReversalMinimartLogAction = (minimartId, callBack) => {
  callAPI("getReversalMinimartLog", `${API.reversalMinimartLog}?minimartId=${minimartId}`,
    "GET", {}, (apiResponse) => callBack(apiResponse));
};

export const deleteReversalMinimartLogAction = (id, callBack) => {
  callAPI("deleteReversalMinimartLog", `${API.reversalMinimartLog}/${id}`,
    "DELETE", {}, (apiResponse) => callBack(apiResponse));
};

export const updateReversalMinimartLogAction = (id, body, callBack) => {
  callAPI("updateReversalMinimartLog", `${API.reversalMinimartLog}/${id}`,
    "PATCH", body, (apiResponse) => callBack(apiResponse));
};

export const getReversalAdditionalExpenseFeeReceiptAction = (loanProcessId, callBack) => {
  callAPI("getReversalAdditionalExpenseFeeReceipt", `${API.reversalAdditionalExpenseFeeReceipt}/${loanProcessId}`,
    "GET", {}, (apiResponse) => callBack(apiResponse));
};

export const deleteReversalAdditionalExpenseFeeReceiptAction = (id, callBack) => {
  callAPI("deleteReversalAdditionalExpenseFeeReceipt", `${API.reversalAdditionalExpenseFeeReceipt}/${id}`,
    "DELETE", {}, (apiResponse) => callBack(apiResponse));
};

export const updateReversalAdditionalExpenseFeeReceiptAction = (id, body, callBack) => {
  callAPI("updateReversalAdditionalExpenseFeeReceipt", `${API.reversalAdditionalExpenseFeeReceipt}/${id}`,
    "PATCH", body, (apiResponse) => callBack(apiResponse));
};

export const getReversalAdditionalExpenseFeeReceiptAuditAction = (loanProcessId, callBack) => {
  callAPI("getReversalAdditionalExpenseFeeReceiptAudit", `${API.reversalAdditionalExpenseFeeReceiptAudit}/${loanProcessId}`,
    "GET", {}, (apiResponse) => callBack(apiResponse));
};

export const deleteReversalAdditionalExpenseFeeReceiptAuditAction = (id, callBack) => {
  callAPI("deleteReversalAdditionalExpenseFeeReceiptAudit", `${API.reversalAdditionalExpenseFeeReceiptAudit}/${id}`,
    "DELETE", {}, (apiResponse) => callBack(apiResponse));
};

export const updateReversalAdditionalExpenseFeeReceiptAuditAction = (id, body, callBack) => {
  callAPI("updateReversalAdditionalExpenseFeeReceiptAudit", `${API.reversalAdditionalExpenseFeeReceiptAudit}/${id}`,
    "PATCH", body, (apiResponse) => callBack(apiResponse));
};

export const getReversalAdministrativeExpenseFeeReceiptAction = (loanProcessId, callBack) => {
  callAPI("getReversalAdministrativeExpenseFeeReceipt", `${API.reversalAdministrativeExpenseFeeReceipt}/${loanProcessId}`,
    "GET", {}, (apiResponse) => callBack(apiResponse));
};

export const deleteReversalAdministrativeExpenseFeeReceiptAction = (id, callBack) => {
  callAPI("deleteReversalAdministrativeExpenseFeeReceipt", `${API.reversalAdministrativeExpenseFeeReceipt}/${id}`,
    "DELETE", {}, (apiResponse) => callBack(apiResponse));
};

export const updateReversalAdministrativeExpenseFeeReceiptAction = (id, body, callBack) => {
  callAPI("updateReversalAdministrativeExpenseFeeReceipt", `${API.reversalAdministrativeExpenseFeeReceipt}/${id}`,
    "PATCH", body, (apiResponse) => callBack(apiResponse));
};

export const getReversalDailyStatusMessengerAdditionalExpenseAction = (dailyStatusMessengerId, callBack) => {
  callAPI("getReversalDailyStatusMessengerAdditionalExpense",
    `${API.reversalDailyStatusMessengerAdditionalExpense}?dailyStatusMessengerId=${dailyStatusMessengerId}`,
    "GET", {}, (apiResponse) => callBack(apiResponse));
};

export const updateReversalDailyStatusMessengerAdditionalExpenseAction = (id, body, callBack) => {
  callAPI("updateReversalDailyStatusMessengerAdditionalExpense", `${API.reversalDailyStatusMessengerAdditionalExpense}/${id}`,
    "PATCH", body, (apiResponse) => callBack(apiResponse));
};



// ── Corrupted minimart city correction ───────────────────────────────────────

/**
 * Dry run: the backend parses the sheet and reports what it would change without
 * writing anything. Always run this first — the sheet is matched on minimart_id
 * alone, so the report is what catches a misaligned sheet.
 */
export const validateMinimartCityFixAction = (file, callBack) => {
  let request = new FormData();
  request.append("file", file);
  callAPI("validateMinimartCityFix", API.minimartCityFixValidate, "POST", request,
    (apiResponse) => callBack(apiResponse), false, true);
};

export const applyMinimartCityFixAction = (file, callBack) => {
  let request = new FormData();
  request.append("file", file);
  callAPI("applyMinimartCityFix", API.minimartCityFixApply, "POST", request,
    (apiResponse) => callBack(apiResponse), false, true);
};

// ── Bulk minimart / micro credit client onboarding from CSV ──────────────────

/** Parses and checks the CSV without registering anything. */
export const validateBulkUploadAction = (url, file, callBack) => {
  let request = new FormData();
  request.append("file", file);
  callAPI("validateBulkUpload", url, "POST", request,
    (apiResponse) => callBack(apiResponse), false, true);
};

/**
 * Uploads the CSV and registers rows in the inclusive [startRow, endRow] range.
 * The backend requires the range — it keeps each batch small and retryable.
 */
export const uploadBulkCsvAction = (url, file, startRow, endRow, callBack) => {
  let request = new FormData();
  request.append("file", file);
  callAPI("uploadBulkCsv", `${url}?startRow=${startRow}&endRow=${endRow}`, "POST", request,
    (apiResponse) => callBack(apiResponse), false, true);
};

/** Re-runs rows already sitting in the staging table, for the same row range. */
export const processPendingBulkRowsAction = (url, startRow, endRow, callBack) => {
  callAPI("processPendingBulkRows", `${url}?startRow=${startRow}&endRow=${endRow}`, "POST", {},
    (apiResponse) => callBack(apiResponse));
};

export const downloadAnalyticsReportAction = (fromDate, toDate, granularity, callBack) => {
  callAPI(
    "downloadAnalyticsReport",
    `${API.analyticsReport}?fd=${fromDate}&td=${toDate}&granularity=${granularity}`,
    "GET",
    {},
    (apiResponse) => callBack(apiResponse),
    true
  );
};

export const getAnalyticsChartDataAction = (fromDate, toDate, granularity, callBack) => {
  callAPI(
    "getAnalyticsChartData",
    `${API.analyticsReportData}?fd=${fromDate}&td=${toDate}&granularity=${granularity}`,
    "GET",
    {},
    (apiResponse) => callBack(apiResponse)
  );
};

export const getReversalCollectionTransferReceiptMappingAction = (loanProcessId, callBack) => {
  callAPI("getReversalCollectionTransferReceiptMapping", `${API.reversalCollectionTransferReceiptMapping}/${loanProcessId}`,
    "GET", {}, (apiResponse) => callBack(apiResponse));
};

export const deleteReversalCollectionTransferReceiptMappingAction = (id, callBack) => {
  callAPI("deleteReversalCollectionTransferReceiptMapping", `${API.reversalCollectionTransferReceiptMapping}/${id}`,
    "DELETE", {}, (apiResponse) => callBack(apiResponse));
};

export const updateReversalCollectionTransferReceiptMappingAction = (id, body, callBack) => {
  callAPI("updateReversalCollectionTransferReceiptMapping", `${API.reversalCollectionTransferReceiptMapping}/${id}`,
    "PATCH", body, (apiResponse) => callBack(apiResponse));
};
